import React from 'react';
import './Link.style.css';

const Link = ({
  children,
  url = '#',
  target = '_blank',
  style = {},
  size = 16,
  weight = 400,
  maxLine = 1,
  color,
  className,
  ...props
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <a
      className={`link_comp ${className}`}
      href={url}
      target={target}
      style={{
        fontSize: size,
        fontWeight: weight,
        WebkitLineClamp: maxLine,
        color: color,
        ...style,
      }}
      {...props}
    >
      {children}
    </a>
  );
};

export default Link;
